<template>
	<div class="leftO">
		<breadcrumb :routerList="[{to:'/xiangmu/pm',title:'费用管理'}]" />
		<div class="left">
			<div class="left3">
				<span class="xunjia">数据总计图表</span>
				<div class="zhongbiao">
					<div class="pie">
						<div class="top">费用总额: <span class="total">102</span>万</div>
						<div class="middle">
							<div class="h-pieChart" id="h_line1Chart" style="width: 4rem; height: 4rem;"></div>
						</div>
						<div class="bottom">
							<div class="used">已用:￥20,600.00</div>
							<div class="more">剩余:￥600,855.00</div>
						</div>
					</div>
					<div class="histogram">
						<div style="font-size: 24px; text-align: center; margin-bottom: 20px;">费用使用情况</div>
						<div class="xiangxi">
							<div class="x-left">
								<span class="span1" style="">超低温</span>
								<span class="span2" style="">低温</span>
								<span class="span3" style="background-color: ">药品</span>
								<span class="span4" style="background-color: ">血液</span>
								<span class="span5" style="background-color: ">太阳能疫苗</span>
								<span class="span6" style="background-color: ">疫苗网</span>
								<span class="span7" style="background-color: ">培养箱</span>
								<span class="span8" style="background-color: ">生物安全</span>
							</div>
							<div class="x-right">
								<el-button style="margin-right: -10px;">分销渠道</el-button>
								<el-button type="primary">产品大类</el-button>
							</div>
						</div>
						<div class="h-histogram" id="h_histogram" style="width: 12rem; height: 4.5rem;"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="right" style="padding: 0;">
			<div style="padding: 40px 45px 0 45px;">
				<span class="xunjia">询价产品信息</span>
				<div>
					<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder clear">
						<el-form-item label="费用编码" style="margin-right: 40px;">
							<el-select v-model="formInline.dingdan" placeholder="模糊搜索" style="width:1.9rem">
								<el-option label="客户一" value="1"></el-option>
								<el-option label="客户二" vakue="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="使用类型" style="margin-right: 40px;">
							<el-select v-model="formInline.dingdan" placeholder="请选择" style="width:2.1rem">
								<el-option label="客户一" value="1"></el-option>
								<el-option label="客户二" vakue="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="创建时间" style="margin-right: 40px;">
							<el-col :span="10">
							  <el-date-picker :clearable="false" type="date" placeholder="请选择" value-format="yyyy-MM-dd" style="width: 1.6rem;"></el-date-picker>
							</el-col>
						</el-form-item>
						<el-form-item class="h-formBtnOut">
							<el-button class="h-btn h-formBtn">检 索</el-button>
						</el-form-item>
						<el-form-item class="h-formBtnOut2">
							<el-button class="h-btn el-icon-plus new-add">新增费用</el-button>
						</el-form-item>
					</el-form>
				</div>
			</div>
			
			<div class="h-table h-mrt30" v-if="clickActive==1">
				<el-table stripe :data="tableData2" @header-click="headerClick" style="width: 100%">
					<el-table-column type="selection" label="全选" width="70">
					</el-table-column>
					<el-table-column type="index" label="序号" width="70">
					</el-table-column>
					<el-table-column prop="customerName" label="产品大类" width="110">
					</el-table-column>
					<el-table-column prop="visitTime" label="物料编码" width="190">
					</el-table-column>
					<el-table-column prop="contact" label="询价状态" width="110">
					</el-table-column>
					<el-table-column prop="objective" label="询价数量" width="100">
					</el-table-column>
					<el-table-column prop="category" label="报价供应商" width="240" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="status" label="可用库存" width="115">
					</el-table-column>
					<el-table-column prop="category" label="付款方式" width="270">
					</el-table-column>
					<el-table-column prop="category" label="创建时间" width="160">
						
					</el-table-column>
					<el-table-column label="操作"
						fiexd="right"
					>
						<template slot-scope="scope">
							<el-button type="text" size="small" class="h-tableLink h-btn">
								查看详情
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="h-tableB h-mrt30" style="padding: 45px">
			<div class="h-tableBL">
				<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导出</el-button>
			</div>
			<div class="h-pagination2">
				<span class="h-pagiLabel">显示数量:</span>
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="4"
				 :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="sizes, prev, pager, next,jumper" :total="400">
				</el-pagination>
			</div>
		</div>
		<!-- 驳回弹窗 -->
		<el-dialog :close-on-click-modal="false" :visible.sync="refuseDialog" class="h-dialog2">
		    <div class="h-dialogImg">
		        <div class="h-disTable">
		            <div class="h-tableCell">
		                <h1>新增费用</h1>
		                <p>New cost</p>
		            </div>
		        </div>
		    </div>
		    <div class="h-formLines">
				<div class="wrapper">
					<el-form :inline="true"  class="top-wrapper demo-ruleForm h-formbLine h-dialogForm">
						<el-form-item label="新增金额" class="h-elformWrap-2" prop="formCon4">
							<el-select placeholder="$200.00">
								<el-option label="是" value="type1"></el-option>
								<el-option label="否" value="type2"></el-option>
							</el-select>
						 </el-form-item>
						 <el-form-item label="费用类型" class="h-elformWrap-2" prop="formCon4">
							<el-select placeholder="100">
								<el-option label="是" value="type1"></el-option>
								<el-option label="否" value="type2"></el-option>
							</el-select>
						  </el-form-item>
					 </el-form>
					<div class="bottom-wrapper">
						<div class="remark">备注</div>
						<div class="substance">
							<textarea class="note" name="" id="" style="width: 100%; height: 150px; line-height: 50px; resize: none; outline: none; border: none;"></textarea>
						</div>
						<div class="outline1 outline"></div>
						<div class="outline2 outline"></div>
						<div class="outline3 outline"></div>
					</div>
				</div>
		        <div style="display:flex;justify-content:center">
					<el-button class="h-btn1 h-formBtn" style="margin-right: 30px;">取消</el-button>
		            <el-button class="h-btn1 h-formBtn" type="primary">提交</el-button>
		        </div>
		    </div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				refuseDialog:true,
				//表单
				all: '全部',
				formInline: {
					dingdan: '',
					customerName: '',
					date3: '',
					type: '',
					value: '',
					bianma: ''
				},
				//表格
				multipleSelection: [],
				tableData2: [{
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: 'SJHS;LT348',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}, {
					customerName: 'XXX项目名称',
					visitTime: 'AHSJ383W5',
					contact: '齐鲁医院',
					objective: 'XXX产品',
					category: '87',
					status: '未转化'
				}],
				clickActive: 1
			}
		},
		methods: {
			onSubmit() {
				// console.log('submit!');
			},
			histogram() {
				let histogram = this.$echarts.init(document.getElementById('h_histogram'))
				let option = {
					tooltip : {
					        trigger: 'axis',
					        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
					            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
					        }
					    },
					    grid: {
					        left: '3%',
					        right: '30%',
					        bottom: '20%',
					        containLabel: true
					    },
					    yAxis:  {
					        type: 'value',
					    },
					    xAxis: {
					        type: 'category',
					        data: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月',]
					    },
					    series: [
					        {
					            name: '超低温',
					            type: 'bar',
								barWidth: '20%',
					            stack: '总量',
					            data: [320, 302, 301, 334, 390, 330, 320, 320, 302, 301, 334, 390],
								itemStyle: {
									normal:{color:'#5BA9FE'}
								}
					        },
					        {
					            name: '低温',
					            type: 'bar',
								barWidth: '20%',
					            stack: '总量',
					            data: [120, 132, 101, 134, 90, 230, 210, 320, 302, 301, 334, 390],
								itemStyle: {
									normal:{color:'#EDE262'}
								}
					        },
					        {
					            name: '药品',
					            type: 'bar',
								barWidth: '20%',
					            stack: '总量',
					            data: [220, 182, 191, 234, 290, 330, 310, 320, 302, 301, 334, 390],
								itemStyle: {
									normal:{color:'#8BA8F4'}
								}
					        },
					        {
					            name: '血液',
					            type: 'bar',
								barWidth: '20%',
					            stack: '总量',
					            data: [150, 212, 201, 154, 190, 330, 410, 320, 302, 301, 334, 390],
								itemStyle: {
									normal:{color:'#71D5EF'}
								}
					        },
					        {
					            name: '太阳能疫苗',
					            type: 'bar',
								barWidth: '20%',
					            stack: '总量',
					            data: [420, 82, 901, 934, 190, 10, 120, 20, 302, 301, 334, 390],
								itemStyle: {
									normal:{color:'#C490C0'}
								}
					        },
							{
							    name: '疫苗网',
							    type: 'bar',
								barWidth: '20%',
							    stack: '总量',
							    data: [420, 82, 901, 934, 190, 10, 120, 20, 302, 301, 334, 390],
								itemStyle: {
									normal:{color:'#90C31E'}
								}
							},
							{
							    name: '培养箱',
							    type: 'bar',
								barWidth: '20%',
							    stack: '总量',
							    data: [420, 82, 901, 934, 190, 10, 120, 20, 302, 301, 334, 390],
								itemStyle: {
									normal:{color:'#4FC3C0'}
								}
							},
							{
							    name: '生物安全',
							    type: 'bar',
								barWidth: '20%',
							    stack: '总量',
							    data: [420, 82, 901, 934, 190, 10, 120, 20, 302, 301, 334, 390],
								itemStyle: {
									normal:{color:'#507BD7'}
								}
							}
					    ]
				}
				histogram.setOption(option);
			},
			lineChart1(){
				let lineChart1 = this.$echarts.init(document.getElementById('h_line1Chart'));
				let option = {
			        /* title : {
			            text: '下单金额',
			            x:'center',
			            y:'70%'
			        }, */
			        tooltip : {
			            trigger: 'item',
			            formatter: "{a} <br/>{b} : {c} ({d}%)"
			        },
			        /* legend: {
			            orient: 'vertical',
			            left: 'center',
			            data: ['缺款：￥26,890','正常：￥8,890'],
			            bottom:'10%',
			        }, */
			        series : [
			            {
			                //name: '下单金额',
			                //barWidth: '50%',
			                type: 'pie',
			                radius : '40%',
			                center: ['50%', '40%'],
			                data:[
			                    {value:20, name:'3%：￥26,890'},
			                    {value:330, name:'97%：￥8,890'},
			                ],
			                itemStyle: {
			                    normal:{
			                        color: function(params) {
			                            let colorList = [
											"#fec10c",
			                                "#5ba9fe"
			                            ];
			                            return colorList[params.dataIndex];
			                        },
			                    },
			                    emphasis: {
			                        shadowBlur: 10,
			                        shadowOffsetX: 0,
			                        shadowColor: 'rgba(0, 0, 0, 0.5)'
			                    }
			                }
			            }
			        ]
				}
				lineChart1.setOption(option);
			}
		},
		mounted(){
			this.lineChart1();
			this.histogram();
		}
	}
</script>
<style scoped>
	.clear::after {
		content: '';
		display: block;
		width: 0;
		height: 0;
		clear: both;
	}
	.left {
		width: 95%;
		background-color: rgb(255, 255, 255);
		padding: 40px 45px 0px;
		margin: 35px;
		border: 1px solid #E2E2E2;
	}
	.xunjia {
		color: #0e75e9;
		display: inline-block;
		padding-left: 10px;
		border-left: 5px solid #0e75e9;
		font-weight: bold;
		font-size: 18px;
		margin-bottom: 20px;
	}
	.zhongbiao {
		display: flex;
	}
	.pie {
		width: 30%;
		flex-shrink: 0;
		display: flex;
		flex-direction: column;
		text-align: center;
		margin-right: 30px;
	}
	.top {
		font-size: 24px;
	}
	.top>.total {
		color: #5BA9FE;
		font-weight: bold;
		font-size: 28px;
	}
	.bottom {
		display: flex;
		flex-direction: column;
		padding-left: 1.5rem;
		text-align: left;
	}
	.used::before {
		content: '';
		width: 30px;
		display: inline-block;
		height: 20px;
		background-color: #fec10c;
		margin-right: 20px;
	}
	.used {
		height: 20px;
		line-height: 20px;
		margin-bottom: 20px;
	}
	.more::before {
		content: '';
		width: 30px;
		display: inline-block;
		height: 20px;
		background-color:#5ba9fe;
		margin-right: 20px;
	}
	.more {
		height: 20px;
		line-height: 20px;
		margin-bottom: 20px;
	}
	.middle {
		width: 350px;
		height: 350px;
	}
	.h-rowCon {
		position: absolute;
		top: -100px;
		left: -220px;
	}
	.histogram {
		flex-grow: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}
	.xiangxi {
		display: flex;
		flex-direction: row;
	}
	.x-left {
		width: 70%;
		flex-shrink: 0;
	}
	.x-left>span {
		width: 20%;
		float: left;
		margin-bottom: 10px;
	}
	.x-left>span::before {
		width: 30px;
		height: 20px;
		display: inline-block;
		content: '';
		margin-right: 10px;
	}
	.x-left .span1::before {
		background-color: #5BA9FE;
	}
	.x-left .span2::before {
		background-color: #5BA9FE;
	}
	.x-left .span3::before {
		background-color: #8BA8F4;
	}
	.x-left .span4::before {
		background-color: #71D5EF;
	}
	.x-left .span5::before {
		background-color: #C490C0;
	}
	.x-left .span6::before {
		background-color: #90C31E;
	}
	.x-left .span7::before {
		background-color: #4FC3C0;
	}
	.x-left .span8::before {
		background-color: #507BD7;
	}
	
	.x-right {
		flex-grow: 1;
	}
	.right {
		width: 95%;
		background-color: rgb(255, 255, 255);
		padding: 40px 45px 60px;
		margin: 35px;
		border: 1px solid #E2E2E2;
	}
	.h-formBtnOut2 {
		float: right;
	}
	.new-add {
		background: #24B5B8;
		color: #FFF;
		border: none;
	}
	.h-table {
		margin-top: 0;
	}
	.enter {
		text-align: center;
	}
	.enter .el-button {
		padding: 18px 43px;
	}
	/* 弹出窗 */
	.wrapper {
		display: flex;
		flex-direction: column;
		padding: 40px;
	}
	.top-wrapper{
		height: 50px;
		flex-shrink: 0;
		display: flex;
		flex-direction: row;
	}
	.h-formbLine .el-form-item__content .el-input__inner {
	 border-radius: 0;
	 background: transparent;
	 color: #868686;
	 border: 0;
	 border-bottom: 1px solid #dedede;
	 height: 0.29rem;
	 line-height: 0.28rem;
	 padding-left: 0.15rem;
	}
	.bottom-wrapper {
		flex-grow: 1;
		display: flex;
		flex-direction: row;
		position: relative;
	}
	.outline {
		width: 80%;
		position: absolute;
		left: 140px;
		border-bottom: 1px solid #ccc;
	}
	.outline1 {
		top: 50px;
	}
	.outline2 {
		top: 100px;
	}
	.outline3 {
		top: 149px;
	}
	.remark {
		width: 85px;
		height: 50px;
		line-height: 50px;
		margin-left: 50px;
		padding-right: 14px;
		text-align: right;
	}
	.remark::before {
		content: '';
		margin-right: 10px;
	}
	.substance {
		width: 90%;
	}
	.h-btn1 {
		width: 107px;
	}
	.h-dialogForm {
		padding: 0;
	}
</style>
<style>
	.h-formbLine2 .el-form-item__label {
		width: 26% !important;
	}

	.h-formbLine2 .el-form-item__content {
		width: 74% !important;
	}
	
</style>
